// import React, { useEffect, useState } from "react";]
import React, { useState, useEffect, useRef, useCallback } from 'react';
//import { useJsApiLoader } from '@react-google-maps/api';


import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import { useSelector, useDispatch } from "react-redux";
import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";
import { Card, Button, InputGroup, Form } from "react-bootstrap";
import { Checkbox } from "../../components/Checkbox";
import { useForm } from "react-hook-form";
import { useToasts } from "react-toast-notifications";
import { setPacienteSesion } from "../../redux/sesion/sesionActions";
import { crearCuenta } from "../../redux/cuenta/cuentaActions";
import { CheckboxText } from "../../components/CheckboxText/index";

import { fechaToInpuHtml } from "../../helpers/fechas";
//import PlaceAutoComplete from "./Components/PlaceAutoComplete";
import { SearchComponent } from "./Components/SearchComponent"

import {
  updatePaciente,
  addPaciente,
  setPaciente,
  addPatologia,
  removePatologia,
  updatePatologia,
} from "../../redux/paciente/pacienteActions";
import { addPoints } from '../../redux/notificaciones/notificacionesActions';
import { updatePacienteInArray } from "../../redux/pacientes/pacientesActions";
import { getPacienteByNumdocAndEmpresaId } from "../../services/firebase/pacientes";
import { TokenPac } from "../../components/TokenPac";

import {
  MainContainer,
  ContainerBody,
  FormStyled,
  STabs,
  STab,
  STabPanel,
  STabList,
  Tabla,
  TablaHeader,
  TablaHeaderLabel,
  TablaHeaderLabelTT,
  StyledInput,
  StyledSelect,
  TablaHeaderText,
  StyledInputTT,
  ContainerPatologias,
  ContainerPatologia,
  StyledButton,
  LabelStyled,
  CotenedorFechaNac,
  ContainerBtn,
  CardBody,
  StyledSelect1,
  StyledInput2,
  StyledInput3,

  PhoneContainer,
  // StyledSelect,
  StyledInputPhone
} from "./style";
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { useLocation } from 'react-router-dom';
import axios from "axios";
import { Loader } from '@googlemaps/js-api-loader';



const ALERGIA = "ALERGIA";
const ESTOMATOLOGICA = "ESTOMATOLOGICA";

const MEDICA = "MEDICA";
const usePatologias = (patologiasPaciente) => {
  const [patologias, setPatologias] = React.useState([
    { llave: "Anestesia Local", checked: false, valor: "", tipo: ALERGIA },
    { llave: "Antibióticos", checked: false, valor: "", tipo: ALERGIA },
    { llave: "Antinflamatorios", checked: false, valor: "", tipo: ALERGIA },
    { llave: "Otros", checked: false, valor: "", tipo: ALERGIA },
    {
      llave: "Abcesos y F.D.",
      checked: false,
      valor: "",
      tipo: ESTOMATOLOGICA,
    },
    { llave: "Agenesias Den", checked: false, valor: "", tipo: ESTOMATOLOGICA },
    { llave: "Bruxismo", checked: false, valor: "", tipo: ESTOMATOLOGICA },
    { llave: "Desgaste Den", checked: false, valor: "", tipo: ESTOMATOLOGICA },
    { llave: "Gingivitis", checked: false, valor: "", tipo: ESTOMATOLOGICA },
    { llave: "Halitosis", checked: false, valor: "", tipo: ESTOMATOLOGICA },
    { llave: "Periodontitis", checked: false, valor: "", tipo: ESTOMATOLOGICA },
    { llave: "Piezas", checked: false, valor: "", tipo: ESTOMATOLOGICA },
    { llave: "Prob Oclusión", checked: false, valor: "", tipo: ESTOMATOLOGICA },
    {
      llave: "Sensibilidad Den",
      checked: false,
      valor: "",
      tipo: ESTOMATOLOGICA,
    },
    {
      llave: "Transtornos ATM",
      checked: false,
      valor: "",
      tipo: ESTOMATOLOGICA,
    },
    { llave: "Otros", checked: false, valor: "", tipo: ESTOMATOLOGICA },
    { llave: "Asma", checked: false, valor: "", tipo: MEDICA },
    { llave: "Cancer", checked: false, valor: "", tipo: MEDICA },
    { llave: "Cardiopatias", checked: false, valor: "", tipo: MEDICA },
    { llave: "Diabetes", checked: false, valor: "", tipo: MEDICA },
    { llave: "Gastropatias", checked: false, valor: "", tipo: MEDICA },
    { llave: "Hepatitis", checked: false, valor: "", tipo: MEDICA },
    { llave: "Hepatopatias", checked: false, valor: "", tipo: MEDICA },
    { llave: "Hipertensión", checked: false, valor: "", tipo: MEDICA },
    { llave: "Hipotension", checked: false, valor: "", tipo: MEDICA },
    { llave: "Nefropatias", checked: false, valor: "", tipo: MEDICA },
    { llave: "Tuberculosis", checked: false, valor: "", tipo: MEDICA },
    { llave: "Transt Mentales", checked: false, valor: "", tipo: MEDICA },
    { llave: "Transt Neuralgicos", checked: false, valor: "", tipo: MEDICA },
    { llave: "Transt Psiquiatrico", checked: false, valor: "", tipo: MEDICA },
    { llave: "Transt Hemorragic", checked: false, valor: "", tipo: MEDICA },
    { llave: "VIH SIDA", checked: false, valor: "", tipo: MEDICA },
    { llave: "Otros", checked: false, valor: "", tipo: MEDICA },
  ]);
  const patologiasFiltradas = patologias.map((item) => {
    let ele = patologiasPaciente.find(
      (it) => it.llave === item.llave && it.tipo === item.tipo
    );
    return ele ? ele : item;
  });
  return [patologiasFiltradas, setPatologias];
};


const countryCodes = [
  { name: "Perú", code: "+51" },
  { name: "México", code: "+52" },
  { name: "Argentina", code: "+54" },
  { name: "Chile", code: "+56" },
  { name: "Colombia", code: "+57" },
  { name: "España", code: "+34" },
];
const sexo = [
  { name: "Masculino" },
  { name: "Femenino" },
];

const fechaACadena = (fecha) => {
  let f;
  if (fecha === null || fecha === undefined || fecha === "" || isNaN(fecha))
    f = new Date();
  else f = fecha;
  const a = f.getFullYear();
  const m = (f.getMonth() + 1).toString().padStart(2, "0");
  const d = f.getDate().toString().padStart(2, "0");
  return `${a}-${m}-${d}`;
};

const libraries = ['places'];
export const Paciente = (props) => {

  const paciente = useSelector((state) => state.paciente);
  const [localPaciente, setLocalPaciente] = useState({ ...paciente });
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  //const [placeDetails, setPlaceDetails] = useState(null);
  const [isPlaceSelected, setIsPlaceSelected] = useState(false)
  const loader = new Loader({
    apiKey: `${process.env.REACT_APP_GOOGLE_MAPS_ID}`, // tu API key de Google Maps
    version: 'weekly',
  });
  const pacientes = useSelector((state) => state.pacientes);
  // const cuenta = useSelector((state) => state.cuenta);
  const dispatch = useDispatch();
  // const [patologias, setPatologias] = usePatologias(paciente.patologias);
  const [patologias, setPatologias] = usePatologias(paciente?.patologias || []);
  const { addToast } = useToasts();
  // const editarPaciente = "Editar Paciente";
  // const nuevoPaciente = "Nuevo Paciente";
  const sesion = useSelector((state) => state.sesion);
  const empresaId = sesion.usuario.empresaId
  // const [startDate, setStartDate] = useState(new Date());
  const [token, setToken] = React.useState("")
  React.useEffect(() => {
    setToken("");
  }, [paciente?.id]);
  const APP_PACIENTE_URL = `${process.env.REACT_APP_APP_PACIENTE_URL}`
  // const endpoint = 'http://127.0.0.1:5001/sysdent-devs/us-central1'
  const API_URL_BASE = `${process.env.REACT_APP_API_URL}`
  const [enableSearch, setEnableSearch] = useState(false);



  const [selectedCode, setSelectedCode] = useState(countryCodes[0].code); // Default Peru (+51)



  const direccion = paciente?.direccion?.direccion || ""; // Valor por defecto si no existe otra dirección



  const inputRef = useRef(null);
  const autocompleteRef = useRef(null);

  // const { isLoaded, loadError } = useJsApiLoader({
  //   googleMapsApiKey: GOOGLE_MAPS_API_KEY,
  //   libraries: libraries,
  // });
  const [selectedSexo, setSelectedSexo] = useState(sexo[0]); // Default: Hombre


  const handleSexoCodeChange = (e) => {
    setSelectedSexo({ name: e.target.value });
    dispatch(setPaciente({ ...paciente, sexo: e.target.value }));
  };

  const handleCountryCodeChange = (e) => {
    setSelectedCode(e.target.value);
    dispatch(setPaciente({ ...paciente, telefono: e.target.value + " " + paciente.telefono?.split(" ")[1] || "" }));
  };

  const handlePhoneChange = (e) => {
    const phoneNumber = e.target.value;
    dispatch(setPaciente({ ...paciente, telefono: phoneNumber }));
  };

  const construirDireccionLegible = (components) => {
    const get = (type) =>
      components.find((comp) => comp.types.includes(type))?.longText || '';

    const calle = get('route');
    const numero = get('street_number');
    const distrito = get('administrative_area_level_3') || get('locality');
    const provincia = get('administrative_area_level_2');
    const departamento = get('administrative_area_level_1');

    const partes = [
      [calle, numero].filter(Boolean).join(' '),
      distrito,
      provincia,
      departamento,
    ];

    return partes.filter(Boolean).join(', ');
  };


  const handleSelectPlace = async (suggestion) => {
    try {
      setEnableSearch(false);
      setIsPlaceSelected(true);
      const place = await suggestion.placePrediction.toPlace();

      const fields = [
        'addressComponents',
        'location',
        'formattedAddress',
      ];
      await place.fetchFields({ fields });

      const addressComponents = place.addressComponents || [];
      const location = place.location;
      const formattedAddress = place.formattedAddress || '';

      // Utilidad para extraer campos del address
      const getComponent = (type) =>
        addressComponents.find((comp) => comp.types.includes(type))?.longText || '';

      // Extraer los componentes relevantes
      const direccion = paciente.direccion.direccion;
      const direccionGoogle = formattedAddress;
      const calle = getComponent('route');
      const numero = getComponent('street_number');
      const distrito = getComponent('administrative_area_level_3') || getComponent('locality');
      const provincia = getComponent('administrative_area_level_2');
      const departamento = getComponent('administrative_area_level_1');
      const pais = getComponent('country');
      const codigoPostal = getComponent('postal_code');
      const latitud = location?.lat() || null;
      const longitud = location?.lng() || null;

      const nuevaDireccion = {
        direccionGoogle,
        direccion,
        calle,
        numero,
        distrito,
        provincia,
        departamento,
        pais,
        codigoPostal,
        latitud,
        longitud,
      };

      console.log('📦 Dirección seleccionada:', nuevaDireccion);

      // Guardar en el store (o tu estado local si prefieres)
      const myPac = { ...paciente };
      dispatch(setPaciente({ ...myPac, direccion: nuevaDireccion }));

    } catch (error) {
      console.error('❌ Error al obtener detalles del lugar:', error);
    }
  };




  const validar = async () => {
    let emailRegex;
    if (paciente.tipDoc === "DNI" && paciente.numDoc.toString().length != 8)
      throw new Error(`DNI inválido`);
    if (paciente.correo && paciente.correo != "") {
      emailRegex =
        /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
      if (!emailRegex.test(paciente.correo)) throw new Error("Correo inválido");
    }
    if (!paciente.fecNac) throw new Error(`Ingrese una fecha válida`);
    let fecNac = new Date(paciente.fecNac);
    let hoy = new Date()

    if (fecNac >= hoy) throw new Error("Fecha de nacimiento inválida");
    if (!paciente.id) // se ejecuta solo si se esta creando un nuevo paciente
      await documentoValido(paciente);
  };


  const documentoValido = async () => {
    const localPaciente = await getPacienteByNumdocAndEmpresaId(paciente.numDoc, empresaId)
    if (localPaciente) throw new Error("Paciente ya existe");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      // Validar los datos antes de continuar
      console.log("Validando paciente", paciente);
      await validar();

      // Asegurarse de que formData.direccion no esté vacío
      if (!paciente.direccion.departamento) {
        throw new Error("Seleccione una direccion de la lista sugerida");
      }
      if (!paciente.sexo) {
        throw new Error("El campo género no puede estar vacío.");
      }

      // Añadir otras propiedades al objeto paciente
      paciente["patologias"] = patologias.filter((it) => it.checked);
      paciente.empresaId = sesion.usuario.empresaId;

      // --- FORZAR MAYÚSCULAS EN NOMBRES Y APELLIDOS ---
      paciente.nombres = paciente.nombres ? paciente.nombres.toUpperCase() : "";
      paciente.apellidos = paciente.apellidos ? paciente.apellidos.toUpperCase() : "";
      // ------------------------------------------------

      // Aquí agregas el campo sexo al objeto paciente si no está presente.

      console.log('Paciente antes de guardar:', paciente);


      // Si el paciente no tiene un id (es nuevo), se añade, si tiene id, se guarda
      if (paciente.id == null || paciente.id === "") {
        paciente.created_by = sesion.usuario.nombres;
        paciente.updated_by = sesion.usuario.nombres;
        dispatch(addPaciente(paciente));
        dispatch(addPoints({ type: 'PACIENTES' }));

      }
      else {

        paciente.updated_by = sesion.usuario.nombres;
        dispatch(updatePaciente(paciente));
      }
      // Actualizar el estado de paciente y otras acciones relacionadas
      dispatch(setPaciente(paciente));
      dispatch(setPacienteSesion(true));
      dispatch(updatePacienteInArray(paciente));

      // Notificar que los cambios se guardaron con éxito
      addToast("Se guardaron los cambios", { appearance: "success" });
    } catch (err) {
      // Manejar errores de validación o de otros tipos
      addToast(err.message, { appearance: "error" });
    }
  };



  const handleCheckChange = (index, item) => {
    if (item.checked) dispatch(addPatologia(item));
    else dispatch(removePatologia(item));
  };
  const handleTextChange = (index, item) => {
    dispatch(updatePatologia(item));
  };

  const getPatologias = (tipo) => {
    if (patologias == null) return;
    let items = patologias
      .filter((it) => it.tipo == tipo)
      .map((item, index) => (
        <ul key={index} className="list-group">
          <li className="list-group-item">
            <CheckboxText
              index={index}
              item={item}
              onCheckChange={handleCheckChange}
              onTextChange={handleTextChange}
            />
          </li>
        </ul>
      ));

    return <ol>{items}</ol>;
  };

  const handleChange = (e) => {

    let myPac = { ...paciente };
    let { name, value } = e.target;
    let updatedValue = value;
    // if (e.target.name == "fecNac") {
    //   var parts = e.target.value.split("-");
    //    updatedValue = new Date(parts[0], parts[1] - 1, parts[2]);

    // }

    console.log("direccion", e.target.value)
    if (e.target.name === "direccion") {
      setEnableSearch(true)
      if (updatedValue === "") {
        // Si la dirección está vacía, restablece los campos relacionados
        updatedValue = { direccion: "", departamento: "", provincia: "", distrito: "", pais: "", lng: "", lat: "" };

      }
      else {
        // Si la dirección no está vacía, actualiza solo el campo de dirección
        updatedValue = { ...paciente.direccion, direccion: e.target.value };

      }



    }



    dispatch(setPaciente({ ...myPac, [e.target.name]: updatedValue }));
  };





  function handleGetToken() {
    const payload = {
      purpose: 'EXISTING_PATIENT_ACCESS',
      pacienteId: paciente.id,
      empresaId: paciente.empresaId,
      expiresAt: null, // Use backend default (7 days)
      seed: paciente.id // Use patient ID as part of the seed
    };

    const accessToken = sesion.usuario.accessToken;
    console.log(`Sending request with token (length: ${accessToken?.length}, starts with: ${accessToken?.substring(0, 15)}...)`);

    fetch(`${process.env.REACT_APP_API_URL}/api/v1/pacientes/generar-invitacion`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${accessToken}`
      },
      body: JSON.stringify(payload)
    })
      .then(async (response) => {
        if (!response.ok) {
          const errorData = await response.json();
          throw new Error(errorData.message || 'Error al generar invitación');
        }
        const res = await response.json();
        setToken(res.tokenId);
      })
      .catch(err => {
        addToast(err.message, { appearance: "error" });
      });
  }


  function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`wrapped-tabpanel-${index}`}
        aria-labelStyledledby={`wrapped-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box p={3}>
            <Typography>{children}</Typography>
          </Box>
        )}
      </div>
    );
  }
  if (sesion.loading || sesion.loading === undefined)
    return <div>...procesando</div>;
  if (sesion.error) return <div>{`Hubo un error ${sesion.error}`}</div>;
  return (
    <MainContainer>

      <ContainerBody>
        <FormStyled className="form form--simple" onSubmit={handleSubmit}>
          <STabs
            selectedTabClassName="is-selected"
            selectedTabPanelClassName="is-selected"
          >
            <STabList>
              <STab>Datos Generales  </STab>
              <STab>Patologías</STab>
            </STabList>

            {/* Panel de Datos Generales */}
            <STabPanel>
              <Card>
                <CardBody>
                  <Tabla>
                    <TablaHeader>
                      {/* Tipo de Documento */}
                      <tr>
                        <TablaHeaderLabel>
                          <LabelStyled htmlFor="tipDoc">Tip. Doc.</LabelStyled>
                        </TablaHeaderLabel>
                        <TablaHeaderText>
                          <StyledSelect
                            name="tipDoc"
                            id="tipDoc"
                            className="form__select"
                            value={paciente.tipDoc || ""}
                            onChange={handleChange}
                            required
                          >
                            <option value="DNI">DNI</option>
                            <option value="CE">CE</option>
                            <option value="RUC">RUC</option>
                          </StyledSelect>
                        </TablaHeaderText>
                      </tr>

                      {/* Número de Documento */}
                      <tr>
                        <TablaHeaderLabel>
                          <LabelStyled htmlFor="numDoc">Num. Doc.</LabelStyled>
                        </TablaHeaderLabel>
                        <TablaHeaderText>
                          <StyledInput
                            className="form__field"
                            name="numDoc"
                            value={paciente.numDoc || ""}
                            onChange={handleChange}
                            autoComplete="off"
                            required
                          />
                        </TablaHeaderText>
                      </tr>

                      {/* Apellidos */}
                      <tr>
                        <TablaHeaderLabel>
                          <LabelStyled htmlFor="apellidos">Apellidos</LabelStyled>
                        </TablaHeaderLabel>
                        <TablaHeaderText>
                          <StyledInput
                            className="form__field"
                            type="text"
                            name="apellidos"
                            value={paciente.apellidos || ""}
                            onChange={handleChange}
                            autoComplete="off"
                            required
                          />
                        </TablaHeaderText>
                      </tr>

                      {/* Nombres */}
                      <tr>
                        <TablaHeaderLabel>
                          <LabelStyled htmlFor="nombres">Nombres</LabelStyled>
                        </TablaHeaderLabel>
                        <TablaHeaderText>
                          <StyledInput
                            className="form__field"
                            type="text"
                            name="nombres"
                            value={paciente.nombres || ""}
                            onChange={handleChange}
                            autoComplete="off"
                            required
                          />
                        </TablaHeaderText>
                      </tr>
                      <tr>
                        <TablaHeaderLabel>
                          <LabelStyled htmlFor="sexo">Género</LabelStyled>
                        </TablaHeaderLabel>
                        <TablaHeaderText>
                          <StyledSelect
                            name="sexo"
                            id="sexo"
                            className="form__select"
                            value={paciente.sexo || ""}
                            onChange={handleChange}
                            required
                          >
                            <option value="" disabled hidden>
                              Seleccione Género
                            </option>
                            <option value="M">Masculino</option>
                            <option value="F">Femenino</option>

                          </StyledSelect>
                        </TablaHeaderText>
                      </tr>


                      {/* Dirección */}
                      <tr>
                        <TablaHeaderLabel>
                          <LabelStyled htmlFor="direccion">Dirección</LabelStyled>
                        </TablaHeaderLabel>
                        <TablaHeaderText>

                          <SearchComponent onPlaceSelected={handleSelectPlace} onTextChange={handleChange} input={direccion} enableSearch={enableSearch} />
                        </TablaHeaderText>

                      </tr>
                      {isPlaceSelected && paciente.direccion.distrito &&
                        <tr><TablaHeaderLabel>
                          <LabelStyled htmlFor="direccion">Ubicacion</LabelStyled>
                        </TablaHeaderLabel>
                          <TablaHeaderText><StyledInput value={`${paciente?.direccion?.distrito}, ${paciente?.direccion?.provincia}, ${paciente.direccion.pais}`}></StyledInput></TablaHeaderText>
                        </tr>}



                      {/* Fecha de Nacimiento */}
                      <tr>
                        <TablaHeaderLabel>
                          <LabelStyled htmlFor="fecNac">Fec. Nac.</LabelStyled>
                        </TablaHeaderLabel>
                        <TablaHeaderText>
                          <StyledInput
                            type="date"
                            name="fecNac"
                            value={paciente.fecNac || ""}
                            onChange={handleChange}
                          />
                        </TablaHeaderText>
                      </tr>

                      {/* Teléfono */}
                      <tr>
                        <TablaHeaderLabel>
                          <LabelStyled htmlFor="telefono">Teléfono</LabelStyled>
                        </TablaHeaderLabel>
                        <TablaHeaderText>

                          <StyledInput
                            name="telefono"
                            type="tel"
                            autoComplete="off"
                            value={paciente.telefono}
                            onChange={handlePhoneChange}
                            required
                          />
                        </TablaHeaderText>
                      </tr>

                      {/* Correo */}
                      <tr>
                        <TablaHeaderLabel>
                          <LabelStyled htmlFor="correo">Correo</LabelStyled>
                        </TablaHeaderLabel>
                        <TablaHeaderText>
                          <StyledInput
                            type="email"
                            name="correo"
                            value={paciente.correo || ""}
                            onChange={handleChange}
                            autoComplete="off"
                          />
                        </TablaHeaderText>
                      </tr>
                      <tr>
                        <TablaHeaderLabel>
                          <LabelStyled
                            className="form__labelStyled"
                            htmlFor="invitar"
                          >
                            Invitacion
                          </LabelStyled>
                        </TablaHeaderLabel>
                        <TablaHeaderText>
                          <TokenPac token={token} onGetToken={handleGetToken} />
                        </TablaHeaderText>
                      </tr>
                    </TablaHeader>
                  </Tabla>
                  <ContainerBtn>
                    <StyledButton type="submit">Guardar</StyledButton>
                  </ContainerBtn>
                </CardBody>
              </Card>
            </STabPanel>

            {/* Panel de Patologías */}
            <STabPanel>
              <Accordion>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                >
                  Médicas
                </AccordionSummary>
                <AccordionDetails>
                  <ContainerPatologias>
                    <ContainerPatologia>
                      {getPatologias(MEDICA)}
                    </ContainerPatologia>
                  </ContainerPatologias>
                </AccordionDetails>
              </Accordion>

              <Accordion>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                >
                  <Typography> Alergias/Alertas</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <ContainerPatologias>
                    <ContainerPatologia>
                      {getPatologias(ALERGIA)}
                    </ContainerPatologia>
                  </ContainerPatologias>
                </AccordionDetails>
              </Accordion>

              <Accordion>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                >
                  <Typography>Estomatológicas</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <ContainerPatologias>
                    <ContainerPatologia>
                      {getPatologias(ESTOMATOLOGICA)}
                    </ContainerPatologia>
                  </ContainerPatologias>
                </AccordionDetails>
              </Accordion>
              <ContainerBtn>
                <StyledButton type="submit" value="Guardar">
                  Guardar
                </StyledButton>
              </ContainerBtn>
            </STabPanel>

          </STabs>
        </FormStyled>
      </ContainerBody>
    </MainContainer>
  );

};